module.exports = __webpack_public_path__ + "static/media/scattered clouds 03d.4dc8014e.png";